import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Linking } from 'react-native';
import { Table } from '../../components/Table';
import { Row, Rows } from '../../components/Rows';

class Content1 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.heading}>
                    {
                        "Appendix 1 - Stock Level"
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Scenario:"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "ABC Fruit Company has achieved great success from the marketing campaign. " +
                        "More and more online orders are done through online shop. " +
                        "This poses heavy stress on delivery team. Delivery team finds that inventory for certain products are in lack. " +
                        "Officers from customer service team are busy calling customers to postpone delivery. " +
                        "Chris is being called to prevent same crisis in the future."
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Chris decides to make the Online Shop check inventory level before customers pick product to their cart."
                    }
                </Text>
            </View>
        );
    }
}

class Content2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightArr: [40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
            widthArr: [100, 150, 430],
            tableHead: ["Name", "Type", "Description"],
            tableData: [
                ["beId", "int(Path)", "Required. Business Entity ID"],
                ["proId", "int(Path)", "Required. Product ID"],
                ["unitId", "int(Query)", "Unit ID (in Product's unit table). If provided, result will return quantity in this unit. By default, result will return in base unit."],
                ["tranId", "int(Query)", "Skip transaction ID. If provided, this transaction will be excluded from the calculation of the result."],
                ["tranType", "string(Query)", "The transaction type of tranId."],
                ["locTypeId", "int(Query)", "Location Type ID. If provided, result will be filtered by this location type."],
                ["asAt", "date(Query)", "As at date. The date stock level calculated up to."],
                ["showLoc", "boolean(Query)", "If true, result will be grouped by location."],
                ["showLotno", "boolean(Query)", "If true, result will be grouped by Lot number."],
                ["includeNonApv", "boolean(Query)", "If true, result will include non-approved records."],
            ],
        }
    }

    render() {
        const state = this.state;

        return (
            <View>
                <Text style={styles.text}>
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/ce01/m18erpws.html#get-inventory-level-per-product')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Get Inventory Level per Product"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "HTTP Request"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET http://[server]/jsf/rfws/erp/trdg/stock/viewLocLvl/{beId}/{proId}"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "Parameters"
                    }
                </Text>
                <Table borderstyle={{ borderWidth: 1 }} style={styles.text}>
                    <Row data={state.tableHead} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
                    <Rows data={state.tableData} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
                </Table>
                <Text style={styles.text}>
                    {
                        "We need to fill in <beId(Business entity ID)> and <proId(Product ID)>."
                    }
                </Text>
                <Text style={styles.text}>
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/m18/m18core_ws.html#get-id-by-code-web-service')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Using Get ID by Code"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                    {
                        ", we can easily find <proId> through the following request:"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET http://[server]/jsf/rfws/entity/getIdByCode/pro?menuCode=pro&code=PRO001"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "For Business Entity, it is a bit tricky. Business Entity is stored in Department. <beId> can be obtained from:"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET http://[server]/jsf/rfws/entity/getIdByCode/dept?menuCode=dept&code=ABCCOMP"
                    }
                </Text>
            </View>
        );
    }
}

class Content3 extends Component {
    render() {
        return (
            <View>
                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {
                        "Understanding the response"
                    }
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 100, paddingBottom: 20 }]}>
                        {
                            '{' +
                            '\n     "basicUnitId":52,'
                        }
                        <Text style={{ color: 'blue' }}>
                            {
                                '\n     "basicQty":7000.0,'
                            }
                        </Text>
                        <Text style={{ color: 'orange' }}>
                            {
                                '\n     "basicCode":"RTUNIT",'
                            }
                        </Text>
                        <Text style={{ color: 'purple' }}>
                            {
                                '\n     "locCode":"L0001-A",'
                            }
                        </Text>
                        <Text style={{ color: 'red' }}>
                            {
                                '\n     "lotno":"RT01_OPENINGS",'
                            }
                        </Text>
                        {
                            '\n     "proId":3081,' +
                            '\n     "qty":7000.0,' +
                            '\n     "unitCode":"RTUNIT",' +
                            '\n     "unitId":3791,' +
                            '\n     "lotnoLot":"A",' +
                            '\n     "locType":31,' +
                            '\n     "locId":40.0,' +
                            '\n     "lotNoId":1681.0' +
                            '\n},'
                        }
                    </Text>
                </View>
                <Text style={styles.text}>
                    {
                        "<basicQty> and <basicCode> shows that there are "
                    }
                    <Text style={{ color: 'blue' }}>
                        {
                            '7000.0'
                        }
                    </Text>
                    {
                        " "
                    }
                    <Text style={{ color: 'orange' }}>
                        {
                            'RTUNIT'
                        }
                    </Text>
                    {
                        " of "
                    }
                    <Text style={{ color: 'red' }}>
                        {
                            'RT01_OPENINGS-002'
                        }
                    </Text>
                    {
                        " in "
                    }
                    <Text style={{ color: 'purple' }}>
                        {
                            'L0001-A"'
                        }
                    </Text>
                    {
                        "."
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "We only need to check if customer’s order quantity exceeds 7000 RTUNIT."
                    }
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    tableCell: {

    },
    border: {
        borderWidth: 1,
    }
});

export { Content1, Content2, Content3 };



// WEBPACK FOOTER //
// ./src/pages/ap2/Content.js